import { CALL_API } from 'redux-api-middleware'
import { replace } from 'react-router-redux'
import { token } from '../../utils'

export const PAYMENT_PAYFORU_REQUEST = 'PAYMENT_PAYFORU_REQUEST'
export const PAYMENT_PAYFORU_SUCCESS = 'PAYMENT_PAYFORU_SUCCESS'
export const PAYMENT_PAYFORU_FAILURE = 'PAYMENT_PAYFORU_FAILURE'
export const CLEAR_QRCODE_REQUEST = 'CLEAR_QRCODE_REQUEST'
export const CLEAR_QRCODE_SUCCESS = 'CLEAR_QRCODE_SUCCESS'
export const CLEAR_QRCODE_FAILURE = 'CLEAR_QRCODE_FAILURE'
export const LOAD_PAYMENT_STATUS_REQUEST = 'LOAD_PAYMENT_STATUS_REQUEST'
export const LOAD_PAYMENT_STATUS_SUCCESS = 'LOAD_PAYMENT_STATUS_SUCCESS'
export const LOAD_PAYMENT_STATUS_FAILURE = 'LOAD_PAYMENT_STATUS_FAILURE'

export const PAYMENT_DEKNERD_PAYFORU_REQUEST = 'PAYMENT_DEKNERD_PAYFORU_REQUEST'
export const PAYMENT_DEKNERD_PAYFORU_SUCCESS = 'PAYMENT_DEKNERD_PAYFORU_SUCCESS'
export const PAYMENT_DEKNERD_PAYFORU_FAILURE = 'PAYMENT_DEKNERD_PAYFORU_FAILURE'

export const CHECK_TUTOR_PAYMENT_STATUS_REQUEST = 'CHECK_TUTOR_PAYMENT_STATUS_REQUEST'
export const CHECK_TUTOR_PAYMENT_STATUS_SUCCESS = 'CHECK_TUTOR_PAYMENT_STATUS_SUCCESS'
export const CHECK_TUTOR_PAYMENT_STATUS_FAILURE = 'CHECK_TUTOR_PAYMENT_STATUS_FAILURE'

export const NOT_AUTHEN = "NOT_AUTHEN"

import {
  COURSE_EP,
  CHECK_PAYMENT_STATUS,
  OVERVIEW_EXAM,
  INFO_EP,
  PAYMENT_PAYFORU_MAINPAGE_DEKNERD,
  PAYMENT_PAYFORU_OPTION_DEKNERD,
  LINE_FORM_DETAIL_EP,
  CHECK_TUTOR_PAYMENT_STATUS,
} from '../../constant'

import {
  loadLineFormDetail
} from '../LineFormDetail/actions'
import {
  loadExamOverview,
  loadInfoPages,
  changeRoute,
} from '../../actions'
export const checkPaymentStatus = (ref, serviceId, backurl) => {
  const form = new FormData()
  form.append('ref', ref)

  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint: CHECK_TUTOR_PAYMENT_STATUS,
        method: 'POST',
        headers: {
          'x-session-token': token,
        },
        body: form,
        types: [
          CHECK_TUTOR_PAYMENT_STATUS_REQUEST,
          {
            type: CHECK_TUTOR_PAYMENT_STATUS_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              // window.location.href = response.url
              // window.location.reload()
              if (response !== null) {
                if (response.responsecode === "01") {
                  // dispatch(loadLineFormDetail(LINE_FORM_DETAIL_EP(serviceId)))
                  console.log(backurl)
                  await dispatch(changeRoute(backurl))
                }
              }
              return response
            },
          },
          // {
          //   type: CHECK_TUTOR_PAYMENT_STATUS_FAILURE,
          //   payload: async (action, state, res) => {
          //     const response = await res.json()
          //     console.log(response)
          //     return response
          //   },
          // },
          CHECK_TUTOR_PAYMENT_STATUS_FAILURE,
        ],
      },
    })
  }
}
export const clearQrcode = () => ({
  type: CLEAR_QRCODE_SUCCESS,
})

export const buyProductFromPayforUMainPageHandle = (id, coinId, productType, paymentType, backurl, tokenMobile = null) => {
  const form = new FormData()
  form.append('idProduct', id)
  form.append('idCoin', coinId)
  form.append('backurl', backurl)
  // form.append('paymenttype', "E-Wallet")
  // form.append('paymenttype', "CounterService")
  // form.append('paymenttype', "Credit")
  // form.append('paymenttype', "SCB")
  // form.append('paymenttype', "KTB")
  // form.append('paymenttype', "BBL")
  // form.append('paymenttype', "CreditPoint")
  // form.append('paymenttype', "BAY")
  // form.append('paymenttype', "Partner")
  // form.append('paymenttype', paymentType)
  form.append('paymenttype', "Main")

  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        // endpoint: PAYMENT_PAYFORU_DEKNERD,
        endpoint: PAYMENT_PAYFORU_MAINPAGE_DEKNERD,
        method: 'POST',
        headers: {
          'x-session-token': tokenMobile !== null ? tokenMobile : token,
        },
        body: form,
        types: [
          PAYMENT_DEKNERD_PAYFORU_REQUEST,
          {
            type: PAYMENT_DEKNERD_PAYFORU_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              // window.location.href = response.url
              // window.location.reload()
              let payForUMainPage = response.split('&')[4].indexOf("url") > -1 ? response.split('&')[4].replace("url=", '') : ''
              console.log(backurl)
              console.log(payForUMainPage)
              if (payForUMainPage !== undefined && payForUMainPage !== '' && response.url !== null) {
                // dispatch(replace(`/redirect?url=${response.url}`))
                window.location.href = payForUMainPage

                let qrData = {
                  amount: 0,
                  qrcode_text: 'notBase64',
                  refId: "00000000",
                }

                if (productType === "course") {
                  await dispatch(loadCoursePage(COURSE_EP(id)))
                  await dispatch({
                    type: PAYMENT_PAYFORU_SUCCESS,
                    data: qrData,
                  })
                } else if (productType === "package") {
                  await dispatch(loadPackagePage(COURSE_EP(id)))
                  await dispatch({
                    type: PAYMENT_PAYFORU_SUCCESS,
                    data: qrData,
                  })
                } else if (productType === "exam") {
                  await dispatch(loadExamOverview(OVERVIEW_EXAM(id)))
                  await dispatch({
                    type: PAYMENT_PAYFORU_SUCCESS,
                    data: qrData,
                  })
                } else if (productType === "live") {
                  await window.location.replace(`/live/${id}/0`)
                } else if (productType === "livestream") {
                  await dispatch(loadInfoPages(INFO_EP))
                }
                // else if(productType === "live"){
                //   await dispatch(loadInfoPages(INFO_EP))
                //   await dispatch({
                //     type: PAYMENT_PAYFORU_SUCCESS,
                //     data: qrData,
                //   })
                // }
              }
              else {
                console.log("barcode")
                let qrData = {
                  amount: response.split('&')[3].replace("amount=", ''),
                  qrcode_text: response.split('&')[5].replace("barcode=", ''),
                  refId: response.split('&')[2].replace("ref=", '')
                }
                await dispatch({
                  type: PAYMENT_PAYFORU_SUCCESS,
                  data: qrData,
                })
                // await dispatch(paymentPayforU(response))
              }
              return response
            },
          },
          // PAYMENT_FAILURE,
          {
            type: PAYMENT_DEKNERD_PAYFORU_FAILURE,
            payload: async (action, state, res) => {
              let response = await res.json()
              console.log(response)
              // let response = ''
              if (res.state === 402) {
                response = 'ผู้ใช้มีคอร์สเรียนนี้แล้ว'
              } else if (res.state === 403) {
                response = 'coin ไม่พอสำหรับซื้อคอร์สนี้'
              } else {
                response = 'ไม่สามารถซื้อคอร์สเรียนนี้ได้'
              }
              // window.location.href = response.url
              // dispatch(replace(`/redirect?url=${response.url}`))
              return response
            },
          },
        ],
      },
    })
  }
}
export const buyProductPayForUTutor = (lineIDTutor, lineIDTutorCustomer, idtutorservice, paymentType, backurl, jobId, tokenMobile = null) => {
  // console.log(jobId)
  const form = new FormData()
  form.append('lineIDTutor', lineIDTutor)
  form.append('lineIDTutorCustomer', lineIDTutorCustomer)
  form.append('idtutorservice', idtutorservice)
  form.append('backurl', backurl)
  // form.append('paymenttype', "E-Wallet")
  // form.append('paymenttype', "CounterService")
  // form.append('paymenttype', "Credit")
  // form.append('paymenttype', "SCB")
  // form.append('paymenttype', "KTB")
  // form.append('paymenttype', "BBL")
  // form.append('paymenttype', "CreditPoint")
  // form.append('paymenttype', "BAY")
  // form.append('paymenttype', "Partner")
  form.append('paymenttype', paymentType)
  // form.append('paymenttype', "Main")

  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        // endpoint: PAYMENT_PAYFORU_DEKNERD,
        endpoint: PAYMENT_PAYFORU_OPTION_DEKNERD,
        method: 'POST',
        // headers: {
        //   'x-session-token': tokenMobile !== null ? tokenMobile : token,
        // },
        body: form,
        types: [
          PAYMENT_DEKNERD_PAYFORU_REQUEST,
          {
            type: PAYMENT_DEKNERD_PAYFORU_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              // window.location.href = response.url
              // window.location.reload()
              let payForUMainPage = response.split('&')[4].indexOf("url") > -1 ? response.split('&')[4].replace("url=", '') : ''
              if (payForUMainPage !== undefined && payForUMainPage !== '' && response.url !== null) {
                // dispatch(replace(`/redirect?url=${response.url}`))
                // console.log("in this")
                window.location.href = payForUMainPage

                let qrData = {
                  amount: 0,
                  qrcode_text: 'notBase64',
                  refId: "00000000",
                }

                if (productType === "course") {
                  await dispatch(loadCoursePage(COURSE_EP(id)))
                  await dispatch({
                    type: PAYMENT_PAYFORU_SUCCESS,
                    data: qrData,
                  })
                } else if (productType === "package") {
                  await dispatch(loadPackagePage(COURSE_EP(id)))
                  await dispatch({
                    type: PAYMENT_PAYFORU_SUCCESS,
                    data: qrData,
                  })
                } else if (productType === "exam") {
                  await dispatch(loadExamOverview(OVERVIEW_EXAM(id)))
                  await dispatch({
                    type: PAYMENT_PAYFORU_SUCCESS,
                    data: qrData,
                  })
                } else if (productType === "live") {
                  await window.location.replace(`/live/${id}/0`)
                } else if (productType === "livestream") {
                  await dispatch(loadInfoPages(INFO_EP))
                }
                // else if(productType === "live"){
                //   await dispatch(loadInfoPages(INFO_EP))
                //   await dispatch({
                //     type: PAYMENT_PAYFORU_SUCCESS,
                //     data: qrData,
                //   })
                // }
              }
              else {
                console.log("barcode")
                let barcode = response.split('&')[5].replace("barcode=", '')
                let qrcode = response.split('&')[8].replace("qrcode_text=", '')
                let qrData = {
                  amount: response.split('&')[3].replace("amount=", ''),
                  qrcode_text: barcode !== '' ? barcode : qrcode,
                  refId: response.split('&')[2].replace("ref=", '')
                }
                await dispatch({
                  type: PAYMENT_PAYFORU_SUCCESS,
                  data: qrData,
                })
                // await dispatch(paymentPayforU(response))
              }
              return response
            },
          },
          // PAYMENT_FAILURE,
          {
            type: PAYMENT_DEKNERD_PAYFORU_FAILURE,
            payload: async (action, state, res) => {
              const response = await res.json()
              // let response = ''
              // console.log(response)
              // console.log(state)
              // console.log(res.status)
              if (res.status === 401) {
                await sessionStorage.setItem("lineTutor",lineIDTutor)
                await sessionStorage.setItem("jobId",jobId)
                await dispatch({
                  type: NOT_AUTHEN,
                  data: res.status,
                })
              }
              // if (res.state === 402) {
              //   response = 'ผู้ใช้มีคอร์สเรียนนี้แล้ว'
              // } else if (res.state === 403) {
              //   response = 'coin ไม่พอสำหรับซื้อคอร์สนี้'
              // } else {
              //   response = 'ไม่สามารถซื้อคอร์สเรียนนี้ได้'
              // }
              // window.location.href = response.url
              // dispatch(replace(`/redirect?url=${response.url}`))
              return response
            },
          },
        ],
      },
    })
  }
}
export const loadPaymentStatus = (endpoint) => {
  return {
    [CALL_API]: {
      endpoint: endpoint,
      method: 'GET',
      headers: {
        'x-session-token': token,
      },
      types: [
        LOAD_PAYMENT_STATUS_REQUEST,
        {
          type: LOAD_PAYMENT_STATUS_SUCCESS,
          payload: async (action, state, res) => {
            const response = await res.json()
            return response
          },
        },
        LOAD_PAYMENT_STATUS_FAILURE,
      ],
    },
  }
}


// WEBPACK FOOTER //
// ./src/components/Payment/action.js